<template>
  <div v-if="v_member" class="">
  	<!-- header start -->
  	<van-nav-bar 
  	  :title="v_member.Member.NickName" 
  	  left-arrow 
  	  fixed 
  	  :z-index="99" 
  	  @click-left="onClickLeft" 
  	  :border="false"
  	/>
  	<div class="navBarSpace"></div>
  	<!-- header end -->

    <div>
      <div class="person-section">
        <div class="hd">
          <van-image
            width="100%"
            height="100%"
            fit="cover"
            :src="v_member.Member.HeadPic"
          />  
        </div>
        <div class="bd">
          <h2 class="name">{{v_member.Member.NickName}}</h2>
          <!-- <P class="accontcode">账号: 13083088012</P>
          <p class="text-center martop10"><van-button size="small" class="mybtn" @click.prevent="">给TA留言</van-button></p> -->
        </div>
      </div>
      
      <div class="person-title">该用户创建的纪念馆</div>
      <div v-if="v_member.MemorialHallList && v_member.MemorialHallList.length > 0">
        <div v-for="item in v_member.MemorialHallList" :key="item.SerialNumber">
          <!-- 双人馆 -->
          <div  class="person-hall-item">
            <router-link :to="{path:'/MemorialHall',query:{id:item.SerialNumber}}">
              <van-swipe class="my-swipe" 
               :loop="false" indicator-color="orange">
                <van-swipe-item v-for="citem in item.DeceasedInformationApiModelList" :key="citem.Id" >
                  <div class="person-hall-list"
                    @click.prevent="getisPrivate(item)"
                    >
                    <div class="hd">
                      <van-image
                        width="100%"
                        height="100%"
                        fit="cover"
                        :src="citem.HeadPhoto"
                      />  
                    </div>
                    <div class="bd">
                      <h2 class="sz-name">{{item.Title}}</h2>
                      <div class="sz-des">
                        <P>逝者: {{citem.DeceasedName}}</P>
                        <P>馆号: TT{{item.SerialNumber}}</P>
                        <P>创建时间: {{$moment(item.AddDateTime).format("YYYY-MM-DD")}}</P>
                        <P>访问量: {{item.ClickCount}}</P>
                      </div>
                    </div>
                  </div>
                </van-swipe-item>
              </van-swipe>
              <img v-if="item.DeceasedInformationApiModelList.length > 1" src="@/assets/images/double_tag_icon.png" class="double-tag" />
            </router-link>
          </div>
        </div>
      </div>
      
      
      <!-- <div class="person-title">亲友馆</div> -->
      <!-- 双人馆 -->
      <!-- <div class="person-hall-item">
        <router-link to="/MemorialHall">
          <van-swipe class="my-swipe" :loop="false" indicator-color="orange">
            <van-swipe-item v-for="item in 2" :key="item.id">
              <div class="person-hall-list">
                <div class="hd">
                  <van-image
                    width="100%"
                    height="100%"
                    fit="cover"
                    src="https://img.yzcdn.cn/vant/cat.jpeg"
                  />  
                </div>
                <div class="bd">
                  <h2 class="sz-name">原广州军区空军政治委员张振先同志纪念馆</h2>
                  <div class="sz-des">
                    <P>逝者:张三</P>
                    <P>馆号:TT1582469852</P>
                    <P>创建时间: 2015-12-10</P>
                    <P>访问量: 184563</P>
                  </div>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
          <img src="@/assets/images/double_tag_icon.png" class="double-tag" />
        </router-link>
      </div> -->
      <!-- 单人馆 -->
      <!-- <div class="person-hall-item">
        <router-link to="/MemorialHall">
          <div class="person-hall-list">
            <div class="hd">
              <van-image
                width="100%"
                height="100%"
                fit="cover"
                src="https://img.yzcdn.cn/vant/cat.jpeg"
              />  
            </div>
            <div class="bd">
              <h2 class="sz-name">原广州军区空军政治委员张振先同志纪念馆</h2>
              <div class="sz-des">
                <P>逝者:姚贝娜纪念馆</P>
                <P>馆号: TT1582469852</P>
                <P>创建时间: 2015-12-10</P>
                <P>访问量: 184563</P>
              </div>
            </div>
          </div>
        </router-link>
      </div> -->
      <!-- 隐私馆弹出 -->
      <van-popup round v-model="isPrivate">
        <div class="dialog-private">
          <h2 class="title">请输入访问密码</h2>
          <div class="control-input">
            <input type="text" placeholder="" ref="password" class="van-field__control">
          </div>
          <van-button round class="mybtn" @click="btncommit" >确定</van-button>
          <p class="tips">温馨提示:该馆属于隐私馆，只有馆主或者知道密码者方可访问，密码由馆主设置，如果您想访问，请主动联系馆主。</p>
          <!-- <van-button size="small" plain round class="mybtn">联系馆主</van-button>-->
          <van-icon name="clear" class="closeBtn" @click="isPrivate = false"/>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'vant'
	export default {
	  data() {
	    return {
        id:0,
        v_member:null,
        isPrivate : false,
        password: null,
        SerialNumber: null,
        
	    };
	  },
	  components: {

    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      init(){
        var that = this;
        this.$store.dispatch({
          type:"GetMemberMemberMemorialHallById",
          Id: that.id,
        }).then(res =>{
          // console.log(res);
          that.v_member = res;
        }, err => {})
      },
      btncommit(){
        var _password = this.$refs.password.value;
        if(_password.trim()==""){
          Toast("请输入密码再点击确定！");
          return;
        }
        if (_password != this.password){
          Toast("纪念馆密码不正确请重新输入！");
          return;
        }
        this.isPrivate = false;
        this.$refs.password.value = "";
        this.$router.push('/MemorialHall?id=' + this.SerialNumber);
      },
      getisPrivate(item){   // 
          if (!item.IsPrivacy){
            this.$router.push('/MemorialHall?id=' + item.SerialNumber);
          }
          this.isPrivate = item.IsPrivacy;
          this.SerialNumber = item.SerialNumber;
          this.password = item.PrivacyPassword;
        },
    },
    created(){
      var that = this;
      this.id = this.$route.query.id;
      this.init()
    }

	};
</script>

<style scoped>
.person-section{
  margin: 15px;
  display: flex;
  align-items: center;
  background-color: #f2f2f2;
}
.person-section>.hd{
  width: 120px;
  height: 120px;
}
.person-section>.bd{
  flex: 1;
  padding: 15px;
}
.person-section>.bd>.name{
  font-size: 15px;
  color: #444;
  font-weight: normal;
}
.person-section>.bd>.accontcode{
  font-size: 12px;
  color: #444;
}
.person-section>.bd>.mybtn{
  margin-top: 8px;
}
.person-hall-item{
  margin:0 15px 15px;
  position: relative;
}
.person-hall-item .double-tag{
  position: absolute;
  top: -4px;
  left: 94px;
  width: 52px;
}
.person-hall-list{
  display: flex;
  align-items: center;
  background-color: #f2f2f2;
  height: 120px;
  position: relative;
  box-sizing: content-box;
}
.person-hall-list>.bd{
  flex: 1;
  overflow: hidden;
  height: 100%;
  padding: 10px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.person-hall-list>.bd>.sz-name{
  font-weight: normal;
  font-size: 15px;
  color: #444;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}
.person-hall-list>.bd>.sz-des{
  margin-top: 6px;
  font-size: 12px;
  color: #666;
  margin-top: 6px;
  line-height: 1.5;
}
.person-hall-list>.hd{
  width: 120px;
  height:120px;
}
.person-title{
  margin: 20px 15px 10px;
  font-size: 13px;
  color: #666;
}
</style>